export default __webpack_public_path__ + "static/media/playCircle.9ccc105d.svg";